import { FC } from "react";
import { ProgramExchangeDetailsType } from "src/Modules/PointsExchange/constants";
import { useWatch } from "antd/es/form/Form";
import ExchangeMain from "../ExchangeMain/ExchangeMain";
import RequiredFields from "../RequiredFields/RequiredFields";
import useFormInstance from "antd/es/form/hooks/useFormInstance";

const ExchangeDetails: FC<Pick<ProgramExchangeDetailsType, "exchangeInfo" | "destinationProgram" | "requiredFields" | "loading">> = ({
  exchangeInfo,
  destinationProgram,
  requiredFields,
  loading,
}) => {
  const formInstance = useFormInstance();
  const points = useWatch("points", formInstance);

  return (
    <div className="flex flex-col gap-6">
      <ExchangeMain destinationProgram={destinationProgram} exchangeInfo={exchangeInfo} points={points} loading={loading} />
      <RequiredFields requiredFields={requiredFields} name="RequiredFields" loading={loading} />
    </div>
  );
};

export default ExchangeDetails;
